"use strict";

const Multiaddr = require('multiaddr');

const reduceValue = (_, v) => v;

const tcpUri = (str, port, parts, opts) => {
  // return tcp when explicitly requested
  if (opts && opts.assumeHttp === false) return "tcp://".concat(str, ":").concat(port); // check if tcp is the last protocol in multiaddr

  let protocol = 'tcp';
  let explicitPort = ":".concat(port);
  const last = parts[parts.length - 1];

  if (last.protocol === 'tcp') {
    // assume http and produce clean urls
    protocol = port === '443' ? 'https' : 'http';
    explicitPort = port === '443' || port === '80' ? '' : explicitPort;
  }

  return "".concat(protocol, "://").concat(str).concat(explicitPort);
};

const Reducers = {
  ip4: reduceValue,
  ip6: (str, content, i, parts) => parts.length === 1 && parts[0].protocol === 'ip6' ? content : "[".concat(content, "]"),
  tcp: (str, content, i, parts, opts) => parts.some(p => ['http', 'https', 'ws', 'wss'].includes(p.protocol)) ? "".concat(str, ":").concat(content) : tcpUri(str, content, parts, opts),
  udp: (str, content) => "udp://".concat(str, ":").concat(content),
  dnsaddr: reduceValue,
  dns4: reduceValue,
  dns6: reduceValue,
  ipfs: (str, content) => "".concat(str, "/ipfs/").concat(content),
  p2p: (str, content) => "".concat(str, "/p2p/").concat(content),
  http: str => "http://".concat(str),
  https: str => "https://".concat(str),
  ws: str => "ws://".concat(str),
  wss: str => "wss://".concat(str),
  'p2p-websocket-star': str => "".concat(str, "/p2p-websocket-star"),
  'p2p-webrtc-star': str => "".concat(str, "/p2p-webrtc-star"),
  'p2p-webrtc-direct': str => "".concat(str, "/p2p-webrtc-direct")
};

module.exports = (multiaddr, opts) => {
  const ma = Multiaddr(multiaddr);
  const parts = multiaddr.toString().split('/').slice(1);
  return ma.tuples().map(tuple => ({
    protocol: parts.shift(),
    content: tuple[1] ? parts.shift() : null
  })).reduce((str, part, i, parts) => {
    const reduce = Reducers[part.protocol];
    if (!reduce) throw new Error("Unsupported protocol ".concat(part.protocol));
    return reduce(str, part.content, i, parts, opts);
  }, '');
};